import React, { FC } from 'react'

import { FormInput, FormSelect } from 'components/FormWithGroup'

import { ArtistFormProps } from './ArtistForm.props'
import { artistFormRules } from 'modules/Artists/constants'

import './ArtistForm.scss'

const ArtistForm: FC<ArtistFormProps> = ({ control, labelsOptions, gpsUnitsOptions, hasOpusIdValue }) => (
  <div className="sbx-row sbx-row-gutter-20 artist-form__row">
    <div className="sbx-col-lg-8 sbx-col-sm-12 sbx-col-xs-24">
      <FormInput
        label="Artist"
        fieldName="name"
        control={control}
        rules={artistFormRules.name}
        placeholder="Artist:"
      />
    </div>
    <div className="sbx-col-lg-8 sbx-col-sm-12 sbx-col-xs-24">
      <FormSelect
        label="Zone"
        fieldName="label_id"
        control={control}
        options={labelsOptions}
        rules={artistFormRules.label_id}
        placeholder="Label:"
      />
    </div>
    <div className="sbx-col-lg-8 sbx-col-sm-12 sbx-col-xs-24">
      <FormInput label="Opus ID" fieldName="opus_id" control={control} />
    </div>
    {!hasOpusIdValue && (
      <>
        <div className="sbx-col-lg-8 sbx-col-sm-12 sbx-col-xs-24">
          <FormInput label="Facebook ID" fieldName="facebook_id" control={control} />
        </div>
      </>
    )}
    <div className="sbx-col-lg-8 sbx-col-sm-12 sbx-col-xs-24">
      <FormSelect
        label="GPS Artist Status"
        fieldName="gps_status"
        placeholder="Artist Status:"
        control={control}
        options={gpsUnitsOptions}
      />
    </div>
    {hasOpusIdValue && (
      <div className="sbx-col-lg-8 sbx-col-sm-12 sbx-col-xs-24">
        <FormInput
          fieldName="spotify_url"
          placeholder="https://open.spotify.com/artist/"
          label="Data Factory Spotify Profile URL"
          control={control}
        />
      </div>
    )}
  </div>
)

export default ArtistForm
